import { render, staticRenderFns } from "./ReceivingReportColumn.vue?vue&type=template&id=42c83e06&"
import script from "./ReceivingReportColumn.vue?vue&type=script&lang=js&"
export * from "./ReceivingReportColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports